__turbopack_context__.v({
  "acc": "classic-header-module__9gL68q__acc",
  "accBtn": "classic-header-module__9gL68q__accBtn",
  "accBtnOpen": "classic-header-module__9gL68q__accBtnOpen",
  "accCaret": "classic-header-module__9gL68q__accCaret",
  "accCol": "classic-header-module__9gL68q__accCol",
  "accGrid": "classic-header-module__9gL68q__accGrid",
  "accInner": "classic-header-module__9gL68q__accInner",
  "accPanel": "classic-header-module__9gL68q__accPanel",
  "accPanelOpen": "classic-header-module__9gL68q__accPanelOpen",
  "actions": "classic-header-module__9gL68q__actions",
  "bar": "classic-header-module__9gL68q__bar",
  "barInner": "classic-header-module__9gL68q__barInner",
  "burger": "classic-header-module__9gL68q__burger",
  "burgerBar": "classic-header-module__9gL68q__burgerBar",
  "chDrop": "classic-header-module__9gL68q__chDrop",
  "cta": "classic-header-module__9gL68q__cta",
  "ctaBlock": "classic-header-module__9gL68q__ctaBlock",
  "drawer": "classic-header-module__9gL68q__drawer",
  "drawerClose": "classic-header-module__9gL68q__drawerClose",
  "drawerHead": "classic-header-module__9gL68q__drawerHead",
  "drawerLink": "classic-header-module__9gL68q__drawerLink",
  "drawerNav": "classic-header-module__9gL68q__drawerNav",
  "drawerOpen": "classic-header-module__9gL68q__drawerOpen",
  "dropdown": "classic-header-module__9gL68q__dropdown",
  "dropdownBuilder": "classic-header-module__9gL68q__dropdownBuilder",
  "dropdownBuilderCol": "classic-header-module__9gL68q__dropdownBuilderCol",
  "dropdownBuilderGrid": "classic-header-module__9gL68q__dropdownBuilderGrid",
  "dropdownCol": "classic-header-module__9gL68q__dropdownCol",
  "dropdownGrid": "classic-header-module__9gL68q__dropdownGrid",
  "logo": "classic-header-module__9gL68q__logo",
  "logoImg": "classic-header-module__9gL68q__logoImg",
  "nav": "classic-header-module__9gL68q__nav",
  "navBtn": "classic-header-module__9gL68q__navBtn",
  "navBtnOpen": "classic-header-module__9gL68q__navBtnOpen",
  "navChevron": "classic-header-module__9gL68q__navChevron",
  "navItem": "classic-header-module__9gL68q__navItem",
  "navLink": "classic-header-module__9gL68q__navLink",
  "navList": "classic-header-module__9gL68q__navList",
  "root": "classic-header-module__9gL68q__root",
  "scrim": "classic-header-module__9gL68q__scrim",
});
